export default __webpack_public_path__ + "assets/ba4cd53f306a0836210018ac3d780c28.svg";